import ListIcon from '@material-ui/icons/ViewList';

import UnitDisciplineList from './UnitDisciplineList';

export default {
    list: UnitDisciplineList,
    icon: ListIcon,
};
